function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M141.409524 0h1275.123809C1496.990476 0 1560.380952 63.390476 1560.380952 138.971429v746.057142c0 78.019048-63.390476 138.971429-141.409523 138.971429H141.409524C63.390476 1024 0 960.609524 0 885.028571V138.971429C0 63.390476 63.390476 0 141.409524 0z",
  fill: "#FFFFFF",
  "p-id": 768
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M282.989714 340.601905l147.407238-221.086476 36.522667 24.33219-147.407238 221.110857zM337.188571 376.198095l147.382858-221.135238 36.522666 24.332191-147.407238 221.135238zM227.961905 302.811429l147.407238-221.110858 36.498286 24.356572-147.407239 221.110857zM1227.776 796.281905l67.632762-101.424762 36.498286 24.33219-67.608381 101.424762zM1094.168381 878.738286l67.632762-101.424762 36.498286 24.33219-67.608381 101.424762zM1171.407238 760.441905l67.632762-101.424762 36.498286 24.356571-67.608381 101.424762zM1037.775238 842.947048l67.632762-101.424762 36.498286 24.33219-67.608381 101.424762zM1147.172571 916.333714l67.608381-101.449143 36.522667 24.332191-67.632762 101.449143zM1118.841905 722.895238l67.632762-101.449143 36.522666 24.332191-67.632762 101.424762z",
  fill: "",
  "p-id": 769
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M632.826131 733.102951a265.752381 265.752381 0 1 0 294.809837-442.249332 265.752381 265.752381 0 1 0-294.809837 442.249332Z",
  fill: "#CE1126",
  "p-id": 770
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M560.761905 365.714286c-41.447619 60.952381-24.380952 143.847619 36.571428 182.857143 60.952381 41.447619 143.847619 24.380952 182.857143-36.571429 41.447619-60.952381 121.904762-78.019048 182.857143-36.571429s78.019048 121.904762 36.571429 182.857143c-80.457143 121.904762-243.809524 156.038095-365.714286 73.142857s-156.038095-243.809524-73.142857-365.714285",
  fill: "#003F87",
  "p-id": 771
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M1228.068571 227.230476l36.522667-24.380952 67.608381 101.424762-36.498286 24.380952zM1118.549333 300.153905l36.522667-24.332191 67.608381 101.424762-36.498286 24.356572zM1037.775238 180.833524l36.522667-24.356572 67.608381 101.424762-36.522667 24.356572zM1147.489524 107.910095l36.522666-24.33219 67.632762 101.424762-36.522666 24.356571zM1214.171429 248.685714l-24.380953-36.571428-60.952381-92.647619-36.571428 24.380952 60.952381 92.647619 19.504762 26.819048 65.828571 102.4 39.009524-24.380953z",
  fill: "",
  "p-id": 772
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M412.038095 758.247619l7.314286 7.314286 65.828571 102.4 36.571429-24.380953-146.285714-221.866666-36.571429 24.380952zM362.057143 802.816l36.522667-24.356571 67.632761 101.424761-36.522666 24.356572zM346.209524 814.32381l-12.190476-17.066667-68.266667-102.4-36.571429 24.380952 146.285715 221.866667 36.571428-24.380952zM284.476952 682.959238l36.522667-24.33219 67.608381 101.424762-36.522667 24.33219z",
  fill: "",
  "p-id": 773
});

var SvgKr = function SvgKr(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1678445848259,
    className: "icon",
    viewBox: "0 0 1560 1024",
    "p-id": 767,
    width: 73.125,
    height: 48,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgKr, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/kr.c7593944.svg";
export { ForwardRef as ReactComponent };